export const FEATURE_HINT_TARGET_ATTR = 'data-feature-hint-target';
export const FEATURE_HINTS_TOOLTIP_ID = 'feature-hints-tooltip';

export const RING_CLASSNAME = 'ring-2 ring-lime-200';

export const FEATURE_HINTS_TOOLTIP_Z_INDEX_CLASS = '!z-[70]';
